module.exports = __webpack_public_path__ + "static/media/Replayer_default_Avatar.507956f2.png";